import React from 'react';
import { StyleSheet } from 'react-native';

import Box from '@components/Box/Box';

export type ProjectOverlayProps = {
  visible: boolean;
  borderRadius?: string;
  backgroundColor?: string;
  children?: React.ReactNode;
  pointerEvents?: 'none' | 'auto' | 'box-none' | 'box-only' | undefined;
};

const ProjectOverlay: React.FC<ProjectOverlayProps> = ({
  visible,
  borderRadius = 'none',
  backgroundColor = 'rgba(0, 0, 0, 0.5)',
  children,
  pointerEvents = 'auto',
}) => {
  if (!visible) return null;

  return (
    <Box
      onStartShouldSetResponder={() => true}
      pointerEvents={pointerEvents}
      style={{
        ...StyleSheet.absoluteFillObject,
        backgroundColor: backgroundColor,
        zIndex: 9999,
      }}
      borderRadius={borderRadius}>
      {children && (
        <Box
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
          pointerEvents='box-none'>
          {children}
        </Box>
      )}
    </Box>
  );
};

export default ProjectOverlay;
